import { render } from "./Navigation.vue?vue&type=template&id=49308a16&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=49308a16&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/barracks/barracks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49308a16"]])

export default __exports__